import BusinessLayout from '../../components/business/BusinessLayout';
import Breadcrumb from '../../components/common/Breadcrumb';

const BusinessHelpPage = () => {
  return (
    <BusinessLayout title="Help & Support">
      <Breadcrumb 
        items={[
          { label: 'Dashboard', href: '/business/dashboard' },
          { label: 'Help', href: '/business/help' }
        ]} 
      />

      <div className="max-w-2xl">
        <div className="bg-white rounded-xl border border-slate-200 p-8">
          <h2 className="text-[20px] font-bold text-slate-900 mb-2">Help & Support</h2>
          <p className="text-[13px] text-slate-600 mb-8">
            Coming soon! Access help documentation, FAQs, and contact support.
          </p>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center">
            <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-blue-100 mb-4">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 16v-4M12 8h.01" />
              </svg>
            </div>
            <p className="text-[13px] text-blue-700 font-medium">
              Help and support features coming soon
            </p>
          </div>
        </div>
      </div>
    </BusinessLayout>
  );
};

export default BusinessHelpPage;
